import React, { useState, useEffect } from "react";
import { useTranslation, Trans } from "next-i18next";
import styles from "../styles/testimonial-with-tabs.module.scss";

type Props = {
  className?: string;
};

const ClientTabsTestimonials: React.FC<Props> = ({ className }) => {
  const { t } = useTranslation("home");
  const [activeIndex, setActiveIndex] = useState(0);

  /** Same client entries as `testimonial.tsx` — only `thought` / `name` / `company` from i18n. */
  const testimonials = [
    {
      thought: t("testimonials.clients.client6.thought"),
      name: t("testimonials.clients.client6.name"),
      company: t("testimonials.clients.client6.company"),
      logo: "/images/trusted-company/aceturtle.svg",
      alt: "Ace Turtle",
    },
    {
      thought: t("testimonials.clients.client7.thought"),
      name: t("testimonials.clients.client7.name"),
      company: t("testimonials.clients.client7.company"),
      logo: "/images/trusted-company/hotplate.svg",
      alt: "Hotplate",
    },
    {
      thought: t("testimonials.clients.client5.thought"),
      name: t("testimonials.clients.client5.name"),
      company: t("testimonials.clients.client5.company"),
      logo: "/images/client-logo/trademarkia.svg",
      alt: "Trademarkia",
    },
    {
      thought: t("testimonials.clients.client3.thought"),
      name: t("testimonials.clients.client3.name"),
      company: t("testimonials.clients.client3.company"),
      logo: "/images/mw-cloudchip.svg",
      alt: "Cloudchipr",
    },
    {
      thought: t("testimonials.clients.client0.thought"),
      name: t("testimonials.clients.client0.name"),
      company: t("testimonials.clients.client0.company"),
      logo: "/images/trusted-company/awign.svg",
      alt: "Awign",
    },
    {
      thought: t("testimonials.clients.client2.thought"),
      name: t("testimonials.clients.client2.name"),
      company: t("testimonials.clients.client2.company"),
      logo: "/images/trusted-company/mindorigin.svg",
      alt: "Mindorigin",
    },
    {
      thought: t("testimonials.clients.client4.thought"),
      name: t("testimonials.clients.client4.name"),
      company: t("testimonials.clients.client4.company"),
      logo: "/images/mw-activeloop.svg",
      alt: "Activeloop",
    },
    // {
    //   thought: t("testimonials.clients.client1.thought"),
    //   name: t("testimonials.clients.client1.name"),
    //   company: t("testimonials.clients.client1.company"),
    //   logo: "/images/mw-dardeen.svg",
    //   alt: "Bardeen",
    // },
  ];

  const testimonialCount = testimonials.length;

  useEffect(() => {
    if (testimonialCount === 0) return;
    const id = window.setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % testimonialCount);
    }, 5000);
    return () => window.clearInterval(id);
  }, [activeIndex, testimonialCount]);

  const current = testimonials[activeIndex];

  return (
    <div className={`mw-testimonial-tabs ${className ?? ""}`}>

        <div className="testimonial-tabs-container">
          <div className={'d-flex'}>
            <div className={"description"}>
              <p>{current.thought}</p>
            </div>
            <aside className={"author"}>
              <p className="heading-author">{current.name}</p>
              <p>{current.company}</p>
              <div className={'logo'}>
                <img
                  src={current.logo}
                  alt={current.alt}
                  width={160}
                  height={48}
                  loading="lazy"
                  decoding="async"
                />
              </div>
            </aside>
          </div>

           
            <div className={'tabs'} role="tablist">
              {testimonials.map((item, index) => (
                <button
                  key={item.logo + index}
                  type="button"
                  role="tab"
                  aria-selected={activeIndex === index}
                  aria-label={`${item.alt} testimonial`}
                  className={`${styles.tabButton} ${
                    activeIndex === index ? 'active' : ""
                  }`}
                  onClick={() => setActiveIndex(index)}
                >
                  <img
                    src={item.logo}
                    alt={item.alt}
                    width={120}
                    height={32}
                    loading="lazy"
                    decoding="async"
                  />
                </button>
              ))}
            </div>
        </div>
    </div>
  );
};

export default ClientTabsTestimonials;
